import { state, transition, invoke, createMachine, reduce } from "robot3";
import { useMachine } from "svelte-robot-factory";
import * as api from '../../api';
import { setSelectedDay } from "../../store";
const storeCalendarDayWithSideEffects = (ctx, ev) => {
    setSelectedDay(ev.data);
    return ctx;
};
const machine = {
    viewing: state(transition('cancel', 'confirm')),
    confirm: state(transition('cancel', 'cancelling'), transition('do-not-cancel', 'viewing')),
    cancelling: invoke(cancelMeeting, transition('done', 'viewing', reduce(storeCalendarDayWithSideEffects)), transition('error', 'error', reduce(storeError))),
    error: state(transition('cancel', 'cancelling'), transition('back', 'viewing')),
};
function storeError(ctx, ev) {
    return Object.assign(Object.assign({}, ctx), { error: ev.error });
}
export function create(meeting, values) {
    return createMachine('viewing', machine, (ctx) => (Object.assign(Object.assign({}, ctx), { meeting, values })));
}
export const createService = (meeting) => {
    const ctx = {
        meeting,
        values: {
            reason: '',
        },
    };
    const m = createMachine(machine, ctx => ctx);
    return useMachine(m, ctx);
};
async function cancelMeeting(ctx) {
    return api.cancelMeeting(ctx.meeting, ctx.values.reason);
}
